import { IUserWebhook } from "../../context/user-webhook";
import { LocaleType } from "../../constants/constants";

export interface IProfile {
    username: string;
    contactEmail: string;
    lang: string;
    isDownload: boolean;
    printerPaperFormat: string;
    updateDate: string;
    webhooks: IUserWebhook[];
}

export class Profile {
    private readonly _username: string;
    private readonly _contactEmail: string;
    private readonly _lang: LocaleType;
    private readonly _isDownload: boolean;
    private readonly _printerPaperFormat: string;
    private readonly _updateDate: string;
    private readonly _webhooks: IUserWebhook[];

    constructor(profile?: IProfile) {
        if (profile) {
            this._updateDate = profile.username;
            this._contactEmail = profile.contactEmail;
            this._lang = profile.lang as LocaleType;
            this._isDownload = profile.isDownload;
            this._printerPaperFormat = profile.printerPaperFormat;
            this._updateDate = profile.updateDate;
            this._webhooks = profile.webhooks;
        }
    }

    get username() {
        return this._username;
    }

    get contactEmail() {
        return this._contactEmail;
    }

    get lang() {
        return this._lang;
    }

    get isDownload() {
        return this._isDownload;
    }

    get printerPaperFormat() {
        return this._printerPaperFormat;
    }

    get updateDate() {
        return this._updateDate;
    }

    get webhooks() {
        return this._webhooks;
    }
}
